import React, { Component } from 'react';
import '../landing.css'
import './slideshow.css'
import Navbar from "../navbar";
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import YouTube from 'react-youtube';
import congo from './images/congo.svg'


export default class hotstar extends Component {
    _onReady(event) {
        // access to player in all event handlers via event.target
        event.target.pauseVideo();
    }
    constructor(props) {
        super(props);
        const windowSize = window.innerWidth;
        let a = (windowSize) - 100;
        let b = (windowSize) - 250;
        if (windowSize < 800) {
            if (windowSize > 600) {
                this.state = {
                    height: b.toString(),
                    width: a.toString(),
                    playerVars: {
                        autoplay: 0,
                    }
                };
            }
            else {
                b = windowSize;
                this.state = {
                    height: b.toString(),
                    width: a.toString(),
                    playerVars: {
                        autoplay: 0,
                    }
                };
            }

        }
        else {
            this.state = {
                height: '400',
                width: '760',
                playerVars: {
                    autoplay: 0,
                }
            };
        }

    }


    componentDidMount() {
        window.addEventListener("resize", this.handleResize);
    }
    componentDidUpdate() {
        window.addEventListener("resize", this.handleResize);

    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }
    handleResize = () => {
        window.location.reload(false);
        const windowSize = window.innerWidth;
        let a = (windowSize) - 100;
        let b = (windowSize) - 250;
        if (windowSize < 800) {
            if (windowSize > 600) {
                this.setState(
                    {
                        height: b.toString(),
                        width: a.toString()
                    }
                );
            }
            else {
                b = windowSize;
                this.setState(
                    {
                        height: b.toString(),
                        width: a.toString()
                    }
                );
            }

        }
        else {
            this.setState(
                {
                    height: '400',
                    width: '760'
                }
            );
        }

        console.log(a.toString());
        console.log(this.state.height);
    };
    render() {
        const opts = {
            height: '400',
            width: '760',
            playerVars: {
                autoplay: 0,
            },
        };
        return (
            <div class="page">
                <div class="banner">
                    <Navbar />
                    <OwlCarousel className='owl-theme' loop margin={10} nav autoWidth={true} center>
                        <div class='item' style={{ width: "100vw" }}>
                            <div class="bb">
                                <div class="video">
                                    <YouTube videoId="7HlB_4_bOM0" opts={this.state} onReady={this._onReady} style={{ position: "relative", margin: "auto", left: "3%", zIndex: "-100" }} />
                                </div>

                                <p class="description" style={{ margin: "auto", width: "95%" }}>Click on <i class="fa fa-youtube-play"> </i> to get in depth instructions to use Hotsatr and get ready for next level experience of ott platform full of movies nad entertainment.</p>
                            </div>

                        </div>

                        <div class='item' style={{ width: "100vw" }}>
                            <div class="bb">
                                <div style={{ width: "95%", margin: "auto", zIndex: "-100" }} class="tut-img h-1" ></div>
                                <p class="description des" style={{ margin: "auto", width: "95%" }}>Open Hotstar by clicking on this <a class="link" href="https://www.hotstar.com/">link</a>.A page will open. Navigate to signin button at top right.</p>
                            </div>

                        </div>
                        <div class='item' style={{ width: "100vw" }}>
                            <div class="bb">
                            <div style={{ width: "95%", margin: "auto", zIndex: "-100" }} class="tut-img h-2" ></div>
                                <p class="description des" style={{ margin: "auto", width: "95%" }}>After successfull login to hotstar. A window consisting all the availaible movi, tv shows ,sports matches will show up , from which you can choose and enjoy the entertainment</p>
                            </div>

                        </div>
                        <div class='item' style={{ width: "100vw" }}>
                            <div class="bb">
                            <div style={{ width: "95%", margin: "auto", zIndex: "-100" }} class="tut-img h-3" ></div>
                                <p class="description des" style={{ margin: "auto", width: "95%" }}>Now search using search bar present at the top of the page to search entertainment and shows according to your will. just type the name and serach results will be displayed. </p>
                            </div>

                        </div>
                        <div class='item' style={{ width: "100vw" }}>
                            <div class="bb">
                            <div style={{ width: "95%", margin: "auto", zIndex: "-100" }} class="tut-img h-4" ></div>
                                <p class="description des" style={{ margin: "auto", width: "95%" }}>Click on the required show from the serach list , boom your entertainment show will start playing, Now just sit back and enjoy the entertainment.</p>
                            </div>

                        </div>
                        <div class='item' style={{ width: "100vw" }}>
                            <div class="bb">
                                <img style={{ width: "95%", margin: "auto", zIndex: "-100" ,height:"360px" }} class="tut-img" src={congo} alt="tut1"></img>
                                <p class="description des" style={{ margin: "auto", width: "95%" }}>Yippe you are all set to use hotstar and take the entertainmentto the next level. <br/> <br/></p>
                            </div>

                        </div>

                    </OwlCarousel>

                </div>
            </div>);
    }

}